import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { Router, provideRouter } from '@angular/router';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { routes } from './app.routes';
import { firstValueFrom, switchMap, tap, catchError, of } from 'rxjs';
import { WsLiveServiceService } from './shared/services/ws-live-service.service';
import { LiveServiceHttpService } from './shared/services/live-service-http.service';
import { ToastService } from './shared/services/toast-service.service';
import { LIVE_FEED_TYPE_TYPE } from './shared/configs/live-feed-type.config';
import * as Sentry from "@sentry/angular";

export function initializeApp(
  liveServiceHttpService: LiveServiceHttpService,
  wsLiveServiceService: WsLiveServiceService,
  router: Router,
  toastService: ToastService
) {
  return (): Promise<any> =>
    firstValueFrom(
      // Check if active live feed session then navigate accordingly otherwise boot normal
      liveServiceHttpService.checkSession().pipe(
        switchMap(res => wsLiveServiceService.setNewConnection(res)),
        catchError(() => of({ liveStreamType: null })),
        tap(res => {
          setTimeout(() => {
            switch (res.liveStreamType) {
              case LIVE_FEED_TYPE_TYPE.THEATRE_CASES:
                router.navigate(['/hospital-theatre-cases'])
                toastService.displaySuccess('Active stream session found.');
                break;
              default:
                router.navigate(['']);
                break;
            }
          }, 0);
        })
      )
    );
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
      deps: [LiveServiceHttpService, WsLiveServiceService, Router, ToastService],
    }
  ]
};
